<div id= "fullPage"style="text-align: center">


<app-entry-page></app-entry-page>
  </div>

  